import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { EProfileDropdownItems } from 'pages/Layout/ProfileDropDown/constants';
import { useProfileDropdownActions } from 'pages/Layout/ProfileDropDown/useProfileDropdownActions';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { Separator } from 'components/ui/separator';

import { SetupChecklistCategory } from './Category';

export const SetupChecklistContentSection: React.FC = () => {
  const { categories, toggleChecklistExpandedState } = useChecklistState();
  const actions = useProfileDropdownActions();

  const handleOpenSupport = () => {
    toggleChecklistExpandedState(false);
    actions[EProfileDropdownItems.SUPPORT]();
  };

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col w-full p-6 bg-base-background rounded-lg">
      {categories.map((category, index, arr) => (
        <div key={index} className="flex flex-col w-full">
          <SetupChecklistCategory category={category} />
          <Separator className="my-5 bg-base-border" />
        </div>
      ))}
      <div
        className="text-xs text-base-mutedForeground text-right cursor-pointer flex justify-end items-center gap-x-2 my-[-10px]"
        onClick={handleOpenSupport}
      >
        Contact support
        <FontAwesomeIcon
          icon={'fa-regular fa-circle-question'}
          className="text-base-mutedForeground"
        />
      </div>
    </div>
  );
};
